export default "/img/LC.c6482be75f5eaa6ad67534e85273da45.png";